export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.30.0';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sentry/browser/esm/version.js
// module id = 64
// module chunks = 0